module.exports = __webpack_public_path__ + "img/Zain-Jordan-EN.ac5afbec.png";